module.exports = __webpack_public_path__ + "static/hero1-8f7eac02b9b3d3a8d3e688484e70b4a7.jpg";